import React, { createContext, useCallback, useContext, useState } from "react"

const PaymentContext = createContext()

const PaymentProvider = ({ order, purchase, onError, children }) => {
  const [addNewPaymentMethod, setAddNewPaymentMethod] = useState(false)
  const [activePaymentMethod, setActivePaymentMethod] = useState()
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false)

  const handleProcessing = useCallback(
    (isProcessing) => {
      setIsPaymentProcessing(isProcessing)
    },
    [setIsPaymentProcessing]
  )

  const handlePurchase = useCallback(
    async (data) => {
      handleProcessing(true)

      return await purchase(data, activePaymentMethod).finally(() => {
        handleProcessing(false)
      })
    },
    [handleProcessing, activePaymentMethod, purchase]
  )

  const selectPaymentMethod = useCallback(
    (type) => {
      setActivePaymentMethod(type)
    },
    [setActivePaymentMethod]
  )

  const value = React.useMemo(
    () => ({
      order,
      activePaymentMethod,
      selectPaymentMethod,
      isPaymentProcessing,
      handlePurchase,
      onError,
      addNewPaymentMethod,
      setAddNewPaymentMethod,
      // handlePurchaseError,
    }),
    [
      order,
      activePaymentMethod,
      selectPaymentMethod,
      isPaymentProcessing,
      handlePurchase,
      onError,
      addNewPaymentMethod,
      setAddNewPaymentMethod,
      // handlePurchaseError,
    ]
  )

  return (
    <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>
  )
}

const usePaymentContext = () => useContext(PaymentContext)

export { PaymentProvider, usePaymentContext }
